import { List } from 'immutable';

import Role from 'entities/role/model';
import { RoleCode } from 'generated/graphql';

export const flattenUserRoles = (userRoles?: Role[] | List<Role>): Role | undefined => {
  if (!userRoles) {
    return undefined;
  }
  // @NOTE-DP: it's 2024 and I don't want to be wrestling with Immutable, really
  const userRolesRaw = ('toJS' in userRoles ? userRoles.toJS() : userRoles) as Role[];

  const ownerRole = userRolesRaw?.find((role) => role?.code === RoleCode.Owner);
  if (ownerRole) {
    return ownerRole;
  }

  // Prefer regular assignable roles
  const firstRegularAssignableRole = userRolesRaw?.find(
    (role) => role?.assignable && !role?.additional
  );
  if (firstRegularAssignableRole) {
    return firstRegularAssignableRole;
  }

  const firstRegularRole = userRolesRaw?.find((role) => !role?.additional);
  if (firstRegularRole) {
    return firstRegularRole;
  }

  return userRolesRaw?.[0] || undefined;
};
